module.exports = __webpack_public_path__ + "img/eg-28-01.2e9a68db.jpg";